export default __webpack_public_path__ + "static/MergeVideos-9f08894a0142a48861b0bf595804d314.png";